import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import BackgroundVideo from "components/Video/BackgroundVideo";
import React from "react";
import * as styles from "./HeroVideo.module.scss";
import EmotionalHeroBannerContent from "components/EmotionalHeroBanner/EmotionalHeroBannerContent";
import PageBuilderButtonCTA, {
  PageBuilderButtonCTAProps
} from "components/PageBuilder/PageBuilderButtonCTA";

type Props = {
  trackingTitle: string | undefined;
  videoId: string;
  title: string | undefined;
  content: BlockContentValue | undefined;
  ctaButtons: PageBuilderButtonCTAProps[] | undefined;
};

const HeroVideo: React.FC<Props> = ({
  videoId,
  trackingTitle,
  title,
  content,
  ctaButtons
}) => {
  const ctaButtonsNodes = ctaButtons?.map((b) => (
    <PageBuilderButtonCTA
      key={b?._key}
      {...b}
      forHero={"inverted"}
      defaultVariant="text"
      inverted
    />
  ));

  return (
    <div className={styles.wrapper}>
      <BackgroundVideo
        videoId={videoId}
        trackingTitle={trackingTitle}
        className={styles.backgroundVideo}
      />
      <div className={styles.contentContainer}>
        <EmotionalHeroBannerContent
          title={title}
          content={content}
          ctaButtons={ctaButtonsNodes}
          bottomSpacing={true}
        />
      </div>
    </div>
  );
};

export default HeroVideo;
